var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exclamation-circle/solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 12C2.75 6.615 7.115 2.25 12.5 2.25C17.885 2.25 22.25 6.615 22.25 12C22.25 17.385 17.885 21.75 12.5 21.75C7.115 21.75 2.75 17.385 2.75 12ZM12.5 8.25C12.6989 8.25 12.8897 8.32902 13.0303 8.46967C13.171 8.61032 13.25 8.80109 13.25 9V12.75C13.25 12.9489 13.171 13.1397 13.0303 13.2803C12.8897 13.421 12.6989 13.5 12.5 13.5C12.3011 13.5 12.1103 13.421 11.9697 13.2803C11.829 13.1397 11.75 12.9489 11.75 12.75V9C11.75 8.80109 11.829 8.61032 11.9697 8.46967C12.1103 8.32902 12.3011 8.25 12.5 8.25ZM12.5 16.5C12.6989 16.5 12.8897 16.421 13.0303 16.2803C13.171 16.1397 13.25 15.9489 13.25 15.75C13.25 15.5511 13.171 15.3603 13.0303 15.2197C12.8897 15.079 12.6989 15 12.5 15C12.3011 15 12.1103 15.079 11.9697 15.2197C11.829 15.3603 11.75 15.5511 11.75 15.75C11.75 15.9489 11.829 16.1397 11.9697 16.2803C12.1103 16.421 12.3011 16.5 12.5 16.5Z",
    fill: "#EF4444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamation);
export default __webpack_public_path__ + "static/media/icon-exclamation.8e364cbff83a769e838c85e5e1909b6c.svg";
export { ForwardRef as ReactComponent };